import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';

import type { RateGroupRow } from '../rate-groups-accordion';

interface TdMinLosRecommendationSignature {
  Args: {
    row: RateGroupRow;
  };
}

const TdMinLosRecommendation = <template>
  <span data-test-id="rate-group-min-los">
    {{#if @row.isLoading}}
      <span
        class="loading-pulse block w-[80px]"
        data-test-id="rate-group-loading"
      ></span>
    {{else}}
      <span class="flex items-center gap-100">
        <PrismIcon
          @color={{if @row.automationOn "on-intelligence" "disabled"}}
          @name={{if @row.automationOn "automation" "automation-off"}}
          @size="small"
        />
        {{@row.formattedRecommendation}}
      </span>
    {{/if}}
  </span>
</template> satisfies TOC<TdMinLosRecommendationSignature>;

export default TdMinLosRecommendation;
